export const formats = [
  "emoji",
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "ordered",
  "list",
  "bullet",
  "indent",
  "link",
  "mention",
  "image",
  "imageBlot",
];

export const isEmptyHtml = (html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const text = doc.body.textContent || "";
  return text.trim() === "";
};
